"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var context_1 = require("App/context");
var Footer_1 = __importDefault(require("./Footer"));
var MenuLeft_1 = __importDefault(require("./MenuLeft"));
var SubBar_1 = __importDefault(require("./SubBar"));
var TopBar_1 = __importDefault(require("./TopBar"));
var AppLayout = function (_a) {
    var children = _a.children;
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var siderProperties = {
        trigger: null,
        width: 250,
        breakpoint: 'lg',
        collapsedWidth: '0',
        className: 'sider',
        collapsed: ctx.navigationCollapsed,
        onBreakpoint: function (broken) {
            ctx.setViewPort(broken ? context_1.EViewPort.mobile : context_1.EViewPort.desktop);
        },
    };
    var showBreadcrumb = function () {
        return ctx.showBreadcrumb ? react_1.default.createElement(SubBar_1.default, null) : null;
    };
    return (react_1.default.createElement(antd_1.Layout, { className: ['acc-app', ctx.viewPort === context_1.EViewPort.mobile ? 'mobile' : 'desktop'].join(' ') },
        react_1.default.createElement(antd_1.Layout.Header, { className: "acc-header" },
            react_1.default.createElement(TopBar_1.default, null)),
        react_1.default.createElement(antd_1.Layout, { className: "acc-app-body" },
            react_1.default.createElement(antd_1.Layout.Sider, __assign({}, siderProperties),
                react_1.default.createElement(MenuLeft_1.default, null)),
            react_1.default.createElement(antd_1.Layout, { className: "acc-content" },
                react_1.default.createElement(antd_1.Layout.Content, { className: "content" },
                    showBreadcrumb(),
                    react_1.default.createElement("div", { className: "acc-content-children" }, children),
                    react_1.default.createElement("div", { className: "acc-content-footer" },
                        react_1.default.createElement(Footer_1.default, null)))))));
};
exports.default = AppLayout;
//# sourceMappingURL=index.js.map